


































































































































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import ProposalProgress from '@/modules/direct-sales/components/proposal-progress/proposal-progress.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ImodelsSelected } from '@/modules/direct-sales/Interfaces/index';
import { numeralService, stringService, httpService, notificationService } from '@/services';
import numeral from 'numeral';
import { CONFIG } from '@/config';
import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import moment from 'moment';
import { httpMixin, momentMixin, numeralMixin } from '@/modules/neodash/mixins';
import PageLoader from '@/components/page-loader/page-loader.vue';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';

@Component({
  components: {
    ProposalProgress,
    ActionBar,
    PageLoader,
    KendoDropdown
  }
})
export default class DirectSalesProposalsSetupPage extends Vue {
  @Prop({ required: true })
  consumerId: number;

  @Prop({ required: true })
  modelSelected: ImodelsSelected[];

  @Prop({ required: false })
  proposalId: number;

  public numeral = numeral;

  public state: any = {
    historic: [],
    namePDF: '',
    nameTablePrice: '',
    idStore: 0,
    idStoreDelivery: 0,
    idConsumer: 0,
    idSalesChannel: 0,
    proposal: {},
    proposalVehicles: [],
    idColor: 0,
    openConfiramationCopyProposal: false,
    confirmationProposal: false,
    statusProposal: [],
    selectedStatusProposal: {},
    idStatusProposal: 0
  };

  public moment = moment;

  public proposal: any = {
    discount: 0,
    units: 0
  };

  public modelDesc: any[] = [];
  public modelsSelectedGrouped: any[] = [];
  public descGroup: any;
  public descGroupFix: any;

  public priceTotalVehicles(itens: any) {
    return _.sumBy(itens, function(o: any) {
      return o['totalSelected'] * o['priceVehicle'];
    });
  }

  public priceTotalDesc(itens: any) {
    return _.sumBy(itens, function(o: any) {
      const price = o['totalSelected'] * o['priceVehicle'];
      return price - (price * parseFloat(o['descReal'])) / 100;
    });
  }

  public appliedDiscount(itens: any) {
    const v1 =
      _.sumBy(itens, function(o: any) {
        return o['idStore'] == o['idStoreDelivery'] ? o['comissionReal'] + o['comissionDelivery'] : o['comissionReal'];
      }) / itens.length;

    return v1.toFixed(2);
  }

  public getRealCommission(itens: any) {
    return _.sumBy(itens, function(o: any) {
      return (
        (parseFloat(o['priceVehicle']) *
          o['totalSelected'] *
          parseFloat(
            o['idStore'] == o['idStoreDelivery'] ? o['comissionReal'] + o['comissionDelivery'] : o['comissionReal']
          )) /
        100
      );
    });
  }

  public generateModelGroup() {
    this.state.idStore = this.modelSelected[0].idStore;
    this.state.idStoreDelivery = this.modelSelected[0].idStoreDelivery;
    this.state.idConsumer = this.modelSelected[0].idConsumer;
    this.state.idSalesChannel = this.modelSelected[0].idSalesChannel;
    this.state.idColor = this.modelSelected[0].idColor;
    this.state.isContactedAutomaker = this.modelSelected[0].isContactedAutomaker;

    this.modelsSelectedGrouped = _(this.modelSelected)
      .groupBy(function(f) {
        return f.idFamily + f.idModel + f.idPrice + f.priceVehicle + f.idColor;
      })
      .map((m: any) => ({
        color: m[0].color,
        familyName: m[0].familyName,
        idFamily: m[0].idFamily,
        idModel: m[0].idModel,
        idPrice: m[0].idPrice,
        idColor: m[0].idColor,
        modelName: m[0].modelName,
        month: m[0].month,
        priceVehicle: m[0].priceVehicle,
        totalSelected: _(m)
          .map((m: any) => m.totalSelected)
          .sum(),
        year: m[0].year
      }))
      .value();
  }

  public getDiscount() {
    const prices = this.modelSelected.map(function(f) {
      return f.idPrice;
    });

    httpService.http
      .post(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/discount/${this.consumerId}`, prices)
      .then((res: AxiosResponse) => {
        // Regra para criar descontos fixos por faixa.
        if (_.some(res.data, s => s.qtdMax != 999)) {
          this.descGroup = _(res.data)
            .groupBy(g => g.idModel)
            .value();

          this.getHistoricSalesClient();
        } else {
          this.descGroupFix = _(res.data)
            .groupBy(g => g.idModel)
            .map((m: any) => ({
              idModel: m[0]['idModel'],
              discount: m
            }))
            .value();

          this.generateModelDescountFix();
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public generateModelDescountFix() {
    if (this.modelsSelectedGrouped && this.descGroupFix) {
      this.modelDesc = _(this.modelsSelectedGrouped)
        .map(
          (m: any) =>
            <ImodelsSelected>{
              month: m.month,
              totalSelected: m.totalSelected,
              year: m.year,
              idFamily: m.idFamily,
              idStore: this.state.idStore,
              idStoreDelivery: this.state.idStoreDelivery,
              idConsumer: this.state.idConsumer,
              idSalesChannel: this.state.idSalesChannel,
              idModel: m.idModel,
              idColor: m.idColor,
              familyName: m.familyName,
              modelName: m.modelName,
              color: m.color,
              idPrice: m.idPrice,
              isDeliveryIndicator:
                this.proposalId &&
                _(this.state.proposalVehicles)
                  .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                  .map((map: any) => map.deliveryIndicator)
                  .value()[0]
                  ? _(this.state.proposalVehicles)
                      .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                      .map((map: any) => map.deliveryIndicator)
                      .value()[0]
                  : false,
              priceVehicle: m.priceVehicle,
              PriceVehicleTotal: m.priceVehicle * m.totalSelected,
              isContactedAutomaker: false,

              isDescountFix: true,

              descMin: _(this.descGroupFix)
                .filter((f: any) => f.idModel == m.idModel)
                .map(
                  (map: any) =>
                    _(map.discount)
                      .orderBy((o: any) => o.percentageDiscountMin)
                      .value()[0].percentageDiscountMin
                )
                .value()[0],
              descMax: _(this.descGroupFix)
                .filter((f: any) => f.idModel == m.idModel)
                .map(
                  (map: any) =>
                    _(map.discount)
                      .orderBy((o: any) => o.percentageDiscountMax)
                      .value()[map.discount.length - 1].percentageDiscountMax
                )
                .value()[0],

              descReal:
                this.proposalId &&
                _(this.state.proposalVehicles)
                  .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                  .map((map: any) => map.percentageDiscountPractice)
                  .value()[0]
                  ? _(this.state.proposalVehicles)
                      .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                      .map((map: any) => map.percentageDiscountPractice)
                      .value()[0]
                  : _(this.descGroupFix)
                      .filter((f: any) => f.idModel == m.idModel)
                      .map(
                        (map: any) =>
                          _(map.discount)
                            .orderBy((o: any) => o.percentageDiscountMax)
                            .value()[0].percentageDiscountMin
                      )
                      .value()[0],

              rangeDiscount: _(this.descGroupFix)
                .filter((f: any) => f.idModel == m.idModel)
                .map((map: any) => map.discount)
                .value()[0],

              percentComissionDesc: 0,

              descMaxComission: 0,

              descMinComission: 0,

              comissionReal:
                this.proposalId &&
                _(this.state.proposalVehicles)
                  .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                  .map((map: any) => map.percentageDiscountPractice)
                  .value()[0]
                  ? _(this.state.proposalVehicles)
                      .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                      .map((map: any) => map.percentageCommissionSale)
                      .value()[0]
                  : _(this.descGroupFix)
                      .filter((f: any) => f.idModel == m.idModel)
                      .map(
                        (map: any) =>
                          _(map.discount)
                            .orderBy((o: any) => o.percentageComissionMax)
                            .value()[0].percentageComissionMax
                      )
                      .value()[0],

              comissionDelivery: _(this.descGroupFix)
                .filter((f: any) => f.idModel == m.idModel)
                .map(
                  (map: any) =>
                    _(map.discount)
                      .orderBy((o: any) => o.percentageComissionDelivery)
                      .value()[0].percentageComissionDelivery
                )
                .value()[0]
            }
        )
        .orderBy((o: any) => o.modelName)
        .orderBy((o: any) => o.familyName)
        .value();
    }
  }

  public generateModelDescount() {
    if (this.modelsSelectedGrouped && this.descGroup) {
      const totalSalesHistoric =
        this.state.historic && this.state.historic.length > 0
          ? _(this.state.historic)
              .map((m: any) => m.total)
              .sum()
          : 0;

      const totalSelected = _(this.modelsSelectedGrouped)
        .map((m: any) => m.totalSelected)
        .sum();

      this.modelDesc = _(this.modelsSelectedGrouped)
        .map(
          (m: any) =>
            <ImodelsSelected>{
              month: m.month,
              totalSelected: m.totalSelected,
              year: m.year,
              idFamily: m.idFamily,
              idStore: this.state.idStore,
              idStoreDelivery: this.state.idStoreDelivery,
              idConsumer: this.state.idConsumer,
              idSalesChannel: this.state.idSalesChannel,
              idModel: m.idModel,
              idColor: m.idColor,
              familyName: m.familyName,
              modelName: m.modelName,
              color: m.color,
              idPrice: m.idPrice,
              isDescountFix: false,
              rangeDiscount: [],
              isDeliveryIndicator:
                this.proposalId &&
                _(this.state.proposalVehicles)
                  .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                  .map((map: any) => map.deliveryIndicator)
                  .value()[0]
                  ? _(this.state.proposalVehicles)
                      .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                      .map((map: any) => map.deliveryIndicator)
                      .value()[0]
                  : false,
              priceVehicle: m.priceVehicle,
              PriceVehicleTotal: m.priceVehicle * m.totalSelected,
              isContactedAutomaker: false,
              descMin: _(this.descGroup[m.idModel])
                .filter(
                  (f: any) =>
                    f.qtdMax > totalSelected + totalSalesHistoric && !(f.qtdMax < totalSelected + totalSalesHistoric)
                )
                .orderBy((p: any) => p.qtdMax)
                .map((map: any) => map.percentageDiscountMin)
                .value()[0],
              descMax: _(this.descGroup[m.idModel])
                .filter(
                  (f: any) =>
                    f.qtdMax > totalSelected + totalSalesHistoric && !(f.qtdMax < totalSelected + totalSalesHistoric)
                )
                .orderBy((p: any) => p.qtdMax)
                .map((map: any) => map.percentageDiscountMax)
                .value()[0],
              percentComissionDesc: _(this.descGroup[m.idModel])
                .filter(
                  (f: any) =>
                    f.qtdMax > totalSelected + totalSalesHistoric && !(f.qtdMax < totalSelected + totalSalesHistoric)
                )
                .orderBy((p: any) => p.qtdMax)
                .map((map: any) => map.percentageComissionDiscount)
                .value()[0],
              descMaxComission: _(this.descGroup[m.idModel])
                .filter(
                  (f: any) =>
                    f.qtdMax > totalSelected + totalSalesHistoric && !(f.qtdMax < totalSelected + totalSalesHistoric)
                )
                .orderBy((p: any) => p.qtdMax)
                .map((map: any) => map.percentageComissionMax)
                .value()[0],
              descMinComission: _(this.descGroup[m.idModel])
                .filter(
                  (f: any) =>
                    f.qtdMax > totalSelected + totalSalesHistoric && !(f.qtdMax < totalSelected + totalSalesHistoric)
                )
                .orderBy((p: any) => p.qtdMax)
                .map((map: any) => map.percentageComissionMin)
                .value()[0],
              descReal:
                this.proposalId &&
                _(this.state.proposalVehicles)
                  .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                  .map((map: any) => map.percentageDiscountPractice)
                  .value()[0]
                  ? _(this.state.proposalVehicles)
                      .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                      .map((map: any) => map.percentageDiscountPractice)
                      .value()[0]
                  : _(this.descGroup[m.idModel])
                      .filter(
                        (f: any) =>
                          f.qtdMax > totalSelected + totalSalesHistoric &&
                          !(f.qtdMax < totalSelected + totalSalesHistoric)
                      )
                      .orderBy((p: any) => p.qtdMax)
                      .map((map: any) => map.percentageDiscountMin)
                      .value()[0],
              comissionReal:
                this.proposalId &&
                _(this.state.proposalVehicles)
                  .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                  .map((map: any) => map.percentageDiscountPractice)
                  .value()[0]
                  ? _(this.state.proposalVehicles)
                      .filter((f: any) => f.idColorVehicle == m.idColor && f.idModelVehicle == m.idModel)
                      .map((map: any) => map.percentageCommissionSale)
                      .value()[0]
                  : _(this.descGroup[m.idModel])
                      .filter(
                        (f: any) =>
                          f.qtdMax > totalSelected + totalSalesHistoric &&
                          !(f.qtdMax < totalSelected + totalSalesHistoric)
                      )
                      .orderBy((p: any) => p.qtdMax)
                      .map((map: any) => map.percentageComissionMax)
                      .value()[0],
              comissionDelivery: _(this.descGroup[m.idModel])
                .filter(
                  (f: any) =>
                    f.qtdMax > totalSelected + totalSalesHistoric && !(f.qtdMax < totalSelected + totalSalesHistoric)
                )
                .orderBy((p: any) => p.qtdMax)
                .map((map: any) => map.percentageComissionDelivery)
                .value()[0]
              //   maxRemaning: _(this.descGroup[m.idModel])
              //     .orderBy((p: any) => p.qtdMax)
              //     .map((m: any) => m.qtdMax)
              //     .value()[
              //     _(this.descGroup[m.idModel])
              //       .orderBy((p: any) => p.qtdMax)
              //       .map((m: any) => m.qtdMax)
              //       .value().length - 1
              //   ]
            }
        )
        .orderBy((o: any) => o.modelName)
        .orderBy((o: any) => o.familyName)
        .value();
    }
  }

  public getHistoricSalesClient() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/historic/sales/vehicle/${this.consumerId}`)
      .then((res: AxiosResponse) => {
        this.state.historic = _(res.data)
          .groupBy(function(f) {
            return f.color + f.idFamily + f.idModel + f.dateSales + f.color + f.typeClient;
          })
          .filter((f: any) => f && !f[0].dateCanceled)
          .map((m: any) => ({
            familyName: m[0].familyName,
            idFamily: m[0].idFamily,
            model: m[0].model,
            idModel: m[0].idModel,
            color: m[0].color,
            typeClient: m[0].typeClient,
            total: m.length
          }))
          .orderBy((o: any) => o.dateSales)
          .value();

        this.generateModelDescount();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public formatarCampoCPF_CNPJ(cpf_cnpj) {
    let value = cpf_cnpj.replace(/(\.|\/|\-)/g, '');
    if (value.length <= 11) {
      value = this.mascaraCpf(cpf_cnpj);
    } else {
      value = this.mascaraCnpj(cpf_cnpj);
    }
    return value;
  }

  public mascaraCpf(valor: string) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  public mascaraCnpj(valor: string) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  }

  public checkCopyProposal() {
    const proposal = this.state.proposal;
    const newProposal = this.getModelProposal();

    if (!(proposal.idConsumer == newProposal.idConsumer && proposal.idStoreSale == newProposal.idStoreSale)) {
      return false;
    } else {
      return (
        _(newProposal.proposalVehicles)
          .filter(
            (f: any) =>
              _(proposal.proposalVehicles)
                .filter(
                  (p: any) =>
                    f.amount == p.amount &&
                    f.deliveryIndicator == p.deliveryIndicator &&
                    f.expectedDeliveryMonth == p.expectedDeliveryMonth &&
                    f.expectedDeliveryYear == p.expectedDeliveryYear &&
                    f.idColorVehicle == p.idColorVehicle &&
                    f.idModelVehicle == p.idModelVehicle &&
                    f.percentageCommissionDelivery == p.percentageCommissionDelivery &&
                    f.percentageCommissionSale == p.percentageCommissionSale &&
                    f.percentageDiscountPractice == p.percentageDiscountPractice &&
                    f.price == p.price
                )
                .value().length <= 0
          )
          .value().length <= 0
      );
    }
  }

  public confirmCompleteProposal() {
    this.state.confirmationProposal = true;
  }

  public gotToCompleteProposal() {
    this.state.confirmationProposal = false;
    if (this.checkCopyProposal() == true) {
      this.state.openConfiramationCopyProposal = true;
      return;
    }

    this.confimProposal();
  }

  public confimProposal() {
    const objProposal = this.getModelProposal();
    httpService.http
      .post(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/${this.state.idConsumer}/createProposal`, objProposal)
      .then((res: AxiosResponse) => {
        notificationService.sendToast({
          status: 1,
          type: 'success',
          message: 'Proposta salva com sucesso!'
        });

        this.$router.push({
          name: DIRECT_SALES_ROUTES.PROPOSALS_COMPLETE,
          params: {
            consumerId: String(this.state.idConsumer),
            proposalId: String(res.data),
            showProgress: String(1)
          }
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getModelProposal() {
    const proposalVehicles = _(this.modelSelected)
      .map((m: any) => ({
        idModelVehicle: m.idModel,
        idColorVehicle: m.idColor,
        amount: m.totalSelected,
        price: m.priceVehicle,
        idPriceVehicle: m.idPrice,
        percentageDiscountPractice: _(this.modelDesc)
          .filter(
            (f: any) =>
              f.idColor == m.idColor && f.idModel == m.idModel && f.idFamily == m.idFamily && f.idPrice == m.idPrice
          )
          .map((d: any) => d.descReal)
          .value()[0],
        percentageCommissionSale: _(this.modelDesc)
          .filter(
            (f: any) =>
              f.idColor == m.idColor && f.idModel == m.idModel && f.idFamily == m.idFamily && f.idPrice == m.idPrice
          )
          .map((d: any) => d.comissionReal)
          .value()[0],
        percentageCommissionDelivery: _(this.modelDesc)
          .filter(
            (f: any) =>
              f.idColor == m.idColor && f.idModel == m.idModel && f.idFamily == m.idFamily && f.idPrice == m.idPrice
          )
          .map((d: any) => (d.idStore == d.idStoreDelivery ? d.comissionDelivery : 0))
          .value()[0],
        expectedDeliveryYear: m.year,
        expectedDeliveryMonth: m.month,
        deliveryIndicator: _(this.modelDesc)
          .filter(
            (f: any) =>
              f.idColor == m.idColor && f.idModel == m.idModel && f.idFamily == m.idFamily && f.idPrice == m.idPrice
          )
          .map((d: any) => d.isDeliveryIndicator)
          .value()[0]
      }))
      .value();

    const obj = {
      idConsumer: this.state.idConsumer,
      idSalesChannel: this.state.idSalesChannel,
      idStoreSale: this.state.idStore,
      idStoreDelivery: this.state.idStoreDelivery,
      idSituation: this.state.idStatusProposal,
      contactedAutomaker: this.state.isContactedAutomaker,
      proposalVehicles: proposalVehicles
    };

    return obj;
  }

  public get totalHistoric() {
    return _(this.state.historic)
      .map((m: any) => m.total)
      .sum();
  }

  public totalSelected() {
    return _(this.modelSelected)
      .map((m: any) => m.totalSelected)
      .sum();
  }

  public get totalGrouped() {
    return (
      _(this.state.historic)
        .map((m: any) => m.total)
        .sum() +
      _(this.modelSelected)
        .map((m: any) => m.totalSelected)
        .sum()
    );
  }

  public goBack() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_AVAILABILITY,
      params: {
        consumerId: String(this.consumerId),
        proposalId: String(this.proposalId)
      }
    });
  }

  public goBackCopy() {
    notificationService.sendToast({
      status: 0,
      type: 'warning',
      message: 'A cópia da proposta foi cancelada.!'
    });
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS
    });
  }

  public getPDF() {
    httpService.httpBlob
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/politics/commercialpoliticsPDF`)
      .then((res: AxiosResponse) => {
        const blob = new Blob([res.data], {
          type: 'application/pdf'
        });
        kendo.saveAs({
          dataURI: window.URL.createObjectURL(blob),
          fileName: res.headers['content-disposition'].substring(21, res.headers['content-disposition'].length)
        });
      })
      .catch((err: AxiosError) => {
        console.log('Error', err);
      });
  }

  public getTablePriceXLSX() {
    httpService.httpBlob
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/politics/tableReferencePriceXLSX`)
      .then((res: AxiosResponse) => {
        const blob = new Blob([res.data], {
          type: 'application/excel'
        });
        kendo.saveAs({
          dataURI: window.URL.createObjectURL(blob),
          fileName: res.headers['content-disposition'].substring(21, res.headers['content-disposition'].length)
        });
      })
      .catch((err: AxiosError) => {
        console.log('Error', err);
      });
  }

  public getInfoPDF() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/politics/commercialpolitics`)
      .then((res: AxiosResponse) => {
        this.state.namePDF = res.data.description;
        this.state.nameTablePrice = res.data.nameReferenceTablePrice;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public subDesc(item) {
    if (item.isDescountFix) {
      const indexFirst = _.findIndex(item.rangeDiscount, (f: any) => f['percentageDiscountMax'] === item.descReal);

      if (indexFirst > 0) {
        item.descReal = item.rangeDiscount[indexFirst - 1].percentageDiscountMax;
        item.comissionReal = item.rangeDiscount[indexFirst - 1].percentageComissionMax;
      }
    } else {
      if (item.percentComissionDesc && item.percentComissionDesc > 0) {
        item.descReal = item.descReal <= item.descMin ? item.descMin : item.descReal - 1;

        const restDesc = item.descMax - item.descReal;
        item.comissionReal = item.descMinComission + restDesc * (item.percentComissionDesc / 100);

        if (item.comissionReal > item.descMaxComission) {
          item.comissionReal = item.descMaxComission;
        }
        return;
      }

      item.descReal = item.descReal <= item.descMin ? item.descMin : item.descReal - 1;
    }
  }

  public sumDesc(item) {
    if (item.isDescountFix) {
      const indexFirst = _.findIndex(item.rangeDiscount, (f: any) => f['percentageDiscountMax'] === item.descReal);

      if (indexFirst < item.rangeDiscount.length - 1) {
        item.descReal = item.rangeDiscount[indexFirst + 1].percentageDiscountMax;
        item.comissionReal = item.rangeDiscount[indexFirst + 1].percentageComissionMax;
      }
    } else {
      if (item.percentComissionDesc && item.percentComissionDesc > 0) {
        item.descReal = item.descReal >= item.descMax ? item.descMax : item.descReal + 1;

        const restDesc = item.descMax - item.descReal;
        item.comissionReal = item.descMinComission + restDesc * (item.percentComissionDesc / 100);

        if (item.comissionReal > item.descMaxComission) {
          item.comissionReal = item.descMaxComission;
        }
      }
    }
  }

  public getPercentPrice(item: any) {
    return item.priceVehicle - (parseFloat(item.priceVehicle) * parseFloat(item.descReal)) / 100;
  }

  public getPercent(item) {
    return (
      (parseFloat(item.priceVehicle) *
        parseFloat(
          item.idStore == item.idStoreDelivery ? item.comissionReal + item.comissionDelivery : item.comissionReal
        )) /
      100
    );
  }

  public getCopyProposal() {
    if (this.proposalId) {
      this.getProposal();
    } else {
      this.getDiscount();
    }
  }

  public getProposal() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/${this.proposalId}/GetProposal`)
      .then((res: AxiosResponse) => {
        this.state.proposal = res.data;
        this.state.proposalVehicles = res.data.proposalVehicles;
        this.getDiscount();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getSituations() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/proposalSituations/`)
      .then((res: AxiosResponse) => {
        this.state.statusProposal = _(res.data)
          .orderBy((o: any) => o.value)
          .value();
        this.state.selectedStatusProposal = this.state.statusProposal[0];
        this.state.idStatusProposal = this.state.statusProposal[0].value;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public mounted() {
    this.getSituations();
    this.generateModelGroup();
    this.getCopyProposal();
    this.getHistoricSalesClient();
    this.getInfoPDF();
  }
}
